export default {"src":"/_next/static/media/infinite-spinner.2767ab27.svg","height":150,"width":300,"blurWidth":0,"blurHeight":0};